import { Component } from '@verndale/core';
import { constEvent } from '../utils/constants';
import MicroModal from 'micromodal';

class Module extends Component {
  setupDefaults() {
    this.eloquaModalId = this.el.dataset.eloquaModalId;
    this.videoModalId = this.el.dataset.videoModalId;
  }

  addListeners() {
    document._on(constEvent.ELOQUA_FORM_SUMBITTED, this.openVideo.bind(this));
  }

  openVideo(e) {
    if (e?.detail?.id !== this.eloquaModalId) return;
    MicroModal.show(this.videoModalId);
  }
}

export default Module;
